// Import necessary modules
import * as THREE from 'three';

let count = document.querySelector('.count')
let frameCounter = 0
const trashtotal = document.querySelectorAll('.trash').length;

// const trashbags = [
//     {
//         // Plastic bottle
//         position: new THREE.Vector3(3.1, -0.48, 2.9),
//         target: new THREE.Vector3(0, 0, 0),
//         element: document.querySelector('.point-trashbag-0'),
//         removed: false
//     },
//     {
//         // Trashbag
//         position: new THREE.Vector3(4.1, -0.48, 3.7),
//         target: new THREE.Vector3(0, 0, 0),
//         element: document.querySelector('.point-trashbag-1'),
//         removed: false
//     },
//     {
//         // Can
//         position: new THREE.Vector3(3.9, -0.58, 3.9),
//         target: new THREE.Vector3(0, 0, 0),
//         element: document.querySelector('.point-trashbag-2'),
//         removed: false
//     },
//     {
//         // Glass bottle
//         position: new THREE.Vector3(3.1, -0.45, 4.4),
//         target: new THREE.Vector3(0, 0, 0),
//         element: document.querySelector('.point-trashbag-3'),
//         removed: false
//     },
//     {
//         // Foil
//         position: new THREE.Vector3(3.65, -0.55, 4.1),
//         target: new THREE.Vector3(0, 0, 0),
//         element: document.querySelector('.point-trashbag-4'),
//         removed: false
//     }
// ]

// export { trashbags }

let ready = false

count.textContent = '0/' + trashtotal

export default class TrashManager {
    constructor(hotspots, experience, resources, teleports) {
        this.hotspots = hotspots
        this.experience = experience
        this.resources = resources
        this.teleports = teleports
        this.trash = []
        this.trashElements = []


        if (this.resources.on('ready', () => {
            // this.teleports.cleanWater = true;

            this.resources.items.mapModel.scene.traverse((child) => {

                if ((child instanceof THREE.Mesh || child instanceof THREE.Group)) {

                    // Floor markers to go to specific wall
                    if (child.name.includes("Trash")) {
                        this.trashElements.push(child);
                    }
                }
            })

            for (const hotspot of this.hotspots.points) {
                if (hotspot.trash) {
                    const button = hotspot.element.parentElement.querySelectorAll('button')[0]
                    const trashIdSplit = hotspot.element.className.split(" ")[0].split("-")
                    const trashId = trashIdSplit[trashIdSplit.length - 1]

                    if (button) {
                        this.trash.push(button);

                        // Add event listener
                        button.addEventListener('click', () => {
                            this.handleTrashClick(hotspot, trashId);
                        });
                    }
                }
            }
        }));
        // this.scene = scene;
    }

    // closePopup() {
    //     this.closest('.popup').remove()
    // }

    // Method to handle click event on trashbags
    handleTrashClick(trash, trashId, event) {
        // event.stopPropagation();  // Prevent event bubbling
        if (!trash.removed) {  // Check if trash is already removed
            trash.removed = true;  // Mark as removed

            // Need to remove the element and html point and add to count
            const trashIdDigit = parseInt(trashId[2], 10) - 1;
            const trashElement = this.trashElements[trashIdDigit];

            if (trashElement) {
                if (trashElement.parent) trashElement.parent.remove(trashElement);

                trashElement.traverse(o => {
                    if (!o.isMesh) return;

                    // dispose geometry
                    if (o.geometry) o.geometry.dispose();

                    // dispose material(s)
                    const disposeMaterial = (m) => {
                        if (!m) return;
                        // dispose any textures on the material
                        for (const key in m) {
                            const value = m[key];
                            if (value && value.isTexture) {
                                value.dispose();
                            }
                        }
                        m.dispose();
                    };

                    if (Array.isArray(o.material)) {
                        o.material.forEach(disposeMaterial);
                    } else {
                        disposeMaterial(o.material);
                    }
                });

            }
            trash.element.parentElement.querySelectorAll('.close')[0].click()
            trash.element.remove();  // Remove the trash element

            this.updateCount();  // Increment the count
        }
    }


    // Method to update the count
    updateCount() {
        count.textContent = parseInt(count.textContent) + 1 + '/' + trashtotal
        if (document.querySelectorAll('.trash').length == 0) { // Change back to 0, 4 for testing
            count.innerHTML = parseInt(count.textContent) + '/' + trashtotal + ` 🎉`;
            const popup = document.querySelector('.trash-popup');
            popup.classList.toggle("show");
            this.teleports.cleanWater = true;
        }
    }

    // Method to update the visibility and interaction of trashbags
    // update(raycaster, camera, sizes, scene, sceneReady, frustum, cameraViewProjectionMatrix) {
    // update(sceneReady) {
    //     // Delay the start of showing the hotspots
    //     sceneReady.on('ready', () => {
    //         window.setTimeout(() => {
    //             ready = true;
    //         }, 500)
    //     })

    //     if (!ready) return;

    //     frameCounter++;

    //     const doRaycast = (frameCounter % 1 === 0); // every 3rd frame

    //     for (const trashbag of this.hotspots.points) {
    //         console.log(trashbag.element.parentElement.querySelector('button')[0])

    //         // const screenPosition = trashbag.position.clone();

    //         // screenPosition.project(camera);
    //         // if (doRaycast) {

    //         //     if (!frustum.containsPoint(trashbag.position)) {
    //         //         trashbag.element.style.opacity = 0; // invisible
    //         //         // trashbag.element.classList.remove('visible');
    //         //         continue;  // Skip the rest of the loop if the trashbag is not in view
    //         //     }

    //         //     raycaster.setFromCamera(screenPosition, camera);
    //         //     const intersects = raycaster.intersectObjects(scene.children, true);

    //         //     if (intersects.length === 0) {
    //         //         trashbag.element.style.opacity = 1; // visible
    //         //         // trashbag.element.classList.add('visible');
    //         //     } else {
    //         //         const intersectionDistance = intersects[0].distance;
    //         //         const trashbagDistance = trashbag.position.distanceTo(camera.position);

    //         //         if (intersectionDistance < trashbagDistance) {
    //         //             // trashbag.element.classList.remove('visible');
    //         //             trashbag.element.style.opacity = 0; // invisible

    //         //         } else {
    //         //             // trashbag.element.classList.add('visible');
    //         //             trashbag.element.style.opacity = 1; // visible
    //         //         }
    //         //     }
    //         // }

    //         // const translateX = screenPosition.x * sizes.width * 0.5;
    //         // const translateY = -screenPosition.y * sizes.height * 0.5;
    //         // trashbag.element.style.transform = `translate(${translateX}px, ${translateY}px)`;

    //         // Add event listener if not already added, only do once
    //         if (!trashbag.listenerAdded) {
    //             trashbag.element.parentElement.querySelector('button')[0].addEventListener('click', (event) => this.handleTrashClick(trashbag, event), false);
    //             trashbag.listenerAdded = true;  // Mark the listener as added
    //         }
    //     };
    // }
}
